import { BaseSubject } from "@zebrabi/observers";
import ActionObserver from "../observers/ActionObserver";

class ActionSubject extends BaseSubject<string, ActionObserver> {}

export default ActionSubject;
